<template>
  <div class="form-container">
    <div
      v-if="permissionFilter.includes(profile.roles.name)"
      class="mb-3 d-flex justify-content-end align-items-center"
    >
      <div class="filter">
        <b-row>
          <b-col>
            <b-form-group
              label="Company"
              label-size="sm"
              content-cols-sm="8"
              label-for="input-horizontal"
              label-class="font-weight-bold"
            >
              <b-form-select
                v-model="company"
                :options="optionsFilter.companies"
                placeholder="Select Company"
                value-field="id"
                text-field="name"
                size="sm"
                @change="$refs.coalAuxiliaryTable.refresh()"
              >
                <template #first>
                  <b-form-select-option
                    :value="null"
                  >
                    All Company
                  </b-form-select-option>
                </template>
              </b-form-select>
            </b-form-group>
          </b-col>
        </b-row>
      </div>
    </div>
    <filters
      :options="optionsFilter"
      @apply ="(filters) => applyFilters(filters)"
      @reset="resetFilters"
    />
    <div class="d-flex justify-content-between align-items-center mb-4">
      <h5>List Coal Auxilliary</h5>
      <div>
        <span>Show</span>
        <b-form-select
          v-model="perPage"
          :options="perPageOptions"
          class="page-option ml-2 mr-2 w-auto"
        />
        <span>Entries</span>
      </div>
      <b-form-group class="m-0">
        <b-form-input
          v-model="search"
          placeholder="Search..."
          @change="$refs.coalAuxiliaryTable.refresh()"
          size="sm"
        ></b-form-input>
      </b-form-group>
    </div>
    <b-table
      hover
      class="mb-4"
      thead-class="table-list-header"
      empty-text="No data"
      ref="coalAuxiliaryTable"
      :items="fetchListCoalAuxiliary"
      :fields="fields"
      :per-page="perPage"
      :current-page="currentPage"
      :sort-by.sync="sortBy"
      :sort-desc.sync="sortDesc"
      :busy="isBusy"
      @row-clicked="goDetail"
      sort-icon-left
      show-empty
      responsive
    >
      <template v-slot:cell(actions)="items">
        <b-dropdown
          v-if="canEdit && (items.item.status.toLowerCase() !== 'submitted')"
          toggle-class="text-dark p-0"
          menu-class="shadow border-0"
          variant="link"
          right
          no-caret
        >
          <template v-slot:button-content>
            <fa-icon
              class="text-info"
              icon="ellipsis-v"
            />
          </template>
          <b-dropdown-item
            @click="goEdit(items.item)"
          >
            Edit
          </b-dropdown-item>
        </b-dropdown>
      </template>
      <template v-slot:table-busy>
        <div class="text-center my-4">
          <b-spinner variant="info" class="spinner-lg" />
        </div>
      </template>
      <template #cell()="{ value, item }">
        <a
          class="d-block h-100 text-dark"
          :href="`/bup-coal-auxilliary/${item.id}/detail`"
        >
          {{ value }}
        </a>
      </template>
      <template #cell(status)="items">
        <div :class="statusChange(items.item.status)">
          {{ items.item.status }}
        </div>
      </template>
    </b-table>
    <div class="d-flex justify-content-end align-items-center">
      <span class="show-entries mr-auto ml-4">
        {{`Show ${totalRows === 0 ? 0 : ((currentPage-1) * perPage) + 1} to ${totalRows > ((currentPage) * perPage) ? ((currentPage) * perPage) : totalRows} of ${totalRows} entries`}}
      </span>
      <b-pagination
        v-model="currentPage"
        :per-page="perPage"
        :total-rows="totalRows"
        pills
        hide-goto-end-buttons
      />
    </div>
    <modal-successful :message="text" />
  </div>
</template>

<script>
import api from '@/api'
import Filters from './Filter'
import ModalSuccessful from '@/partials/ModalSuccessful'
import { hasPermission } from '@/utils/permissions'
import { COAL_AUXILLIARY_EDIT } from '@/fixtures'

export default {
  components: {
    ModalSuccessful,
    Filters
  },

  data: () => ({
    profile: JSON.parse(localStorage.getItem('profile')),
    canEdit: hasPermission(COAL_AUXILLIARY_EDIT),
    isBusy: false,
    search: '',
    text: '',
    stringifiedFilter: '',
    currentPage: localStorage.getItem('currentPage') ?? 1,
    perPage: 10,
    totalRows: localStorage.getItem('totalRows') ?? 0,
    sortBy: 'periode_doc',
    sortDesc: true,
    fields: [
      { key: 'actions', sortable: false, tdClass: 'text-center', thClass: 'start', thStyle: 'width:50px' },
      { key: 'periode_doc', label: 'Period', sortable: true },
      { key: 'company_name', label: 'Company Name', sortable: true },
      { key: 'contractor_name', label: 'Contractor', sortable: true },
      { key: 'contract_number', label: 'Contract Number', sortable: true },
      { key: 'status', label: 'Status', sortable: true, thClass: 'end' }
    ],
    items: [
      { id: 1, periode_doc: 'APRIL-2022', company_name: 'PT Bharinto Ekatama', contractor_name: 'ABC Sejahtera', contract_number: '123456', status: 'Draft' },
      { id: 2, periode_doc: 'MARCH-2022', company_name: 'PT Bharinto Ekatama', contractor_name: 'ABC Sejahtera', contract_number: '123456', status: 'Submitted' },
      { id: 3, periode_doc: 'FEBUARY-2022', company_name: 'PT Bharinto Ekatama', contractor_name: 'ABC Sejahtera', contract_number: '123456', status: 'Submitted' }
    ],
    contractor: {},
    optionsFilter: {
      companies: [],
      contractors: []
    },
    perPageOptions: [
      { value: 10, text: '10' },
      { value: 20, text: '20' },
      { value: 30, text: '30' }
    ],
    company: null,
    permissionFilter: [
      'Super Admin',
      'Finance Jakarta',
      'Administrator'
    ]
  }),

  mounted() {
    this.fetchCompany()
    this.fetchContractor()
  },

  methods: {
    async fetchListCoalAuxiliary() {
      const data = await api.coalAuxiliary.list({
        sort_by: this.sortBy,
        sort_dir: this.sortDesc ? 'DESC' : 'ASC',
        page: this.currentPage,
        limit: this.perPage,
        search: this.search,
        filter_value: this.stringifiedFilter,
        company_id: this.company,
        is_active: true
      })
      this.totalRows = data ? data.count : 100
      this.items = data ? data.rows : []
      this.items.map(d => {
        if (!d.has_summary && d.status === 'Approved') {
          d._rowVariant = 'success'
        }
      })
      localStorage.removeItem('currentPage', this.currentPage)
      localStorage.removeItem('totalRows', this.totalRows)
      this.visible = false
      return this.items
    },
    async fetchCompany() {
      try {
        this.optionsFilter.companies = await api.company.list_active()
      } catch ({ response }) {
        this.error = response.data.message
      }
    },
    async fetchContractor() {
      try {
        this.optionsFilter.contractors = await api.contractor.list()
      } catch ({ response }) {
        this.error = response.data.message
      }
    },
    goDetail(item) {
      localStorage.setItem('currentPage', this.currentPage)
      localStorage.setItem('totalRows', this.totalRows)
      localStorage.setItem('isEdit', false)
      window.open(`/bup-coal-auxilliary/${item.id}/detail`)
    },
    goEdit(item) {
      localStorage.setItem('currentPage', this.currentPage)
      localStorage.setItem('totalRows', this.totalRows)
      localStorage.setItem('isEdit', true)
      this.$router.push({ path: `/bup-coal-auxilliary/${item.id}/edit` })
    },
    statusChange(status) {
      if (status === 'Draft') {
        return 'draft'
      } else if (status === 'Submitted' || status === 'Approved') {
        return 'approved'
      } else if (status === 'Revise') {
        return 'revised'
      } else if (status === 'Waiting Approval') {
        return 'waiting-approval'
      } else {
        return 'waiting-approval'
      }
    },
    resetFilters() {
      this.stringifiedFilter = ''
      this.$refs.coalAuxiliaryTable.refresh()
    },
    applyFilters(filters) {
      if (filters.periode[0] === null && filters.periode[1] === null) {
        filters.periode = []
        this.stringifiedFilter = ''
      }
      if (!filters.contractor_id) {
        filters.contractor_id = ''
        this.stringifiedFilter = ''
      }
      if (filters.periode.length && filters.periode[0] && filters.periode[1] && filters.contractor_id) {
        this.stringifiedFilter = `periode:${filters.periode[0]};${filters.periode[1]},contractor_name:${filters.contractor_id}`
        this.sortBy = 'periode_doc'
      } else if (filters.periode.length) {
        this.stringifiedFilter = `periode:${filters.periode[0]};${filters.periode[1]}`
        this.sortBy = 'periode_doc'
      } else if (filters.contractor_id) {
        this.stringifiedFilter = `contractor_name:${filters.contractor_id}`
        this.sortBy = 'periode_doc'
      }
      this.$refs.coalAuxiliaryTable.refresh()
    }
  }
}
</script>

<style lang="scss" scoped>
.table {
  width: 100%;
}
</style>
